import { API_PATH } from 'constants/app';
import { api } from 'helper/api';
import { formatE164Phone } from 'helper/form';

export function request(phone: string): Promise<void> {
  const phoneWithE164Format = formatE164Phone(phone);
  return api.build().withoutAuth()
    .post(`${API_PATH}/accounts/${phoneWithE164Format}/otp`);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/repositories/otp.ts